

export const hollyReviewerReviewHinge = {
  _id: 'hollyReviewerReviewHingeId',
  email: 'holly@email.com',
  profileReviewId: 'hollyProfileReviewHingeId',
  reviewerProfileId: 'hollyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Holly! This will really help me!',
  profileReviewedFirstName: 'Gatsby',
}

export const luigiReviewerReviewBumble = {
  _id: 'luigiReviewerReviewBumbleId',
  email: 'luigi@email.com',
  profileReviewId: 'luigiProfileReviewBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Luigi! This will really help me!',
  profileReviewedFirstName: 'Gatsby',
}

export const frodoReviewerReviewTinder = {
  _id: 'frodoReviewerReviewTinderId',
  email: 'frodo@email.com',
  profileReviewId: 'frodoProfileReviewTinderId',
  reviewerProfileId: 'frodoReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Frodo! This will really help me!',
  profileReviewedFirstName: 'Gatsby',
}